import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_FINAL_CTA } from '@src/constants/LeadGenerationConstants/index';

const FinalCta = ({ steps }) => {
  return (
    <section className={styles.final} id="cta">
      <div className={styles.wrap}>
        <div>
          <span className={styles.eyebrow}>Ready to build?</span>
          <h2>Start Shipping Real AI Apps.</h2>
          <p>
            Apply now — a program advisor will walk you through fit, schedule and fees. No payment
            until you enrol.
          </p>
          <LeadGenerationButton text="Apply Now" buttonLocation={LEAD_GEN_FINAL_CTA} />
        </div>
        <ol className={styles.steps}>
          {steps.map((step) => (
            <li key={step.h}>
              <div>
                <b>{step.h}</b>
                <span>{step.p}</span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default FinalCta;
